export default "<input type=\"text\" [attr.class]=\"defaultCss\" />"